@if (selected) {
  <table-material
    id-table="controller-config-predefined-items-description-id"
    [header]="header"
    [data]="selected.PredefinedItemsDescription"
    [getValue]="getData"
    [selectable]="false"
    (onNewElement)="onNewForm()"
    (onRefresh)="refresh()"
    >
  </table-material>
}